import { useMutation } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestFinanceAccountResponse } from "@/types";
import { CreateFinanceAccountRequestDTO } from "@/types";
import { useQueryClient } from "@tanstack/react-query";

async function createFinanceAccount(
  request: CreateFinanceAccountRequestDTO
): Promise<RequestFinanceAccountResponse> {
  const response = await httpRequest.post<RequestFinanceAccountResponse>(
    `/finance-accounts`,
    request
  );
  return response.data;
}

export function useCreateFinanceAccountMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFinanceAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accounts"] });
    },
  });
}
